export const apiUrl = `https://api.github.com/repos/${process.env.STORYBOOK_GITHUB_OWNER!}/${process.env.STORYBOOK_GITHUB_REPOSITORY!}`;
export const issueUrl = `${apiUrl}/issues`;
export const labelUrl = `${apiUrl}/labels`;
export const githubHeaders = {
    Accept: 'application/vnd.github+json',
    Authorization: `Bearer ${process.env.STORYBOOK_GITHUB_PUBLIC_TOKEN!}`,
    'X-GitHub-Api-Version': '2022-11-28'
};